import React, { Component } from 'react';
import { formatData, AssessmentInnerContainer, valueThenSubHeaderSection, valueThenSubTextDivs } from './examUtils';
import './Exam.css'

class AssessmentTreatment extends Component {
	state = {}

	render() {

		const formattedTreatments = (formatData(this.props.data));

		const { Accessories, Bracing, Compression, Footwear, 'Orthotics List': OrthoticsList } = formattedTreatments || {};

		const orderedBrannockKeys = ['Gender', 'Recommended Shoe Size', 'Heel to Toe', 'Heel to Ball', 'Width']
		const orderedRecommendedKeys = ['Home', 'Work', 'Leisure', 'Sport']
		const orderedMeasurementsKeys = ['Ankle', 'Calf', 'Thigh', 'Hip Waist', 'Calf Length', 'Leg Length', 'Comments']
		const orderedKneeBraceKeys = ['Side', 'Type', 'Model', 'Thigh Size', 'Knee Size', 'Calf Size', 'Comments']
		const orderedAnkleBraceKeys = ['Side', 'Type', 'Model', 'Ankle Size', 'Shoe Size', 'Comments']

										
		if (Object.keys(formattedTreatments).filter(key => key !== 'Updated At').length === 0) {
			return (
				<div className="Exam__details-container">
					<div className="Exam__details-container-header">
						<h2>Treatment</h2>
					</div>
					<div className="Exam__details">
						<div className="Exam__details-not-found">No Treatment Data Found</div>
					</div>
				</div>
			)
		}

		return (
			<div className="Exam__details-container">
				<div className="Exam__details-container-header">
					<h2>Treatment</h2>
				</div>
				{OrthoticsList && (
					OrthoticsList.map((orthotic, i) => (
						<AssessmentInnerContainer header={i === 1 ? 'Orthotics Second Pair' : 'Orthotics'}>
							{orthotic.Types && valueThenSubHeaderSection('Type', orthotic.Types)}
							{orthotic.Style && valueThenSubHeaderSection('Style', orthotic.Style)}
							{orthotic.Length && valueThenSubHeaderSection('Length', orthotic.Length)}
							{orthotic['Casting Technique'] && valueThenSubHeaderSection('Casting Technique', orthotic['Casting Technique'])}
							{orthotic.Materials && (
								<React.Fragment key={i}>
									<h3 className="Exam__details-sub-header">Materials:</h3>
									{valueThenSubTextDivs({value: orthotic.Materials.Values})}
									{valueThenSubTextDivs({value: orthotic.Materials.Thickness, label: 'Thickness', units: 'mm'})}
									{valueThenSubTextDivs({value: orthotic.Materials.Comments, label: 'Comments'})}
								</React.Fragment>
							)}
							{orthotic.Postings && (
								<React.Fragment>
									<h3 className="Exam__details-sub-header">Postings:</h3>
									{(orthotic.Postings.Forefoot && (
										orthotic.Postings.Forefoot.Location
												|| orthotic.Postings.Forefoot.Measurement 
												|| orthotic.Postings.Forefoot.Units)
									) && (
										<div className="Exam__details-sub-text-section">
											<div className="Exam__details-sub-text">Forefoot</div>
											<div className="Exam__details-sub-text">
														Right: {orthotic.Postings.Forefoot.Location.Right && orthotic.Postings.Forefoot.Location.Right + ' '}
												{orthotic.Postings.Forefoot.Measurement.Right && orthotic.Postings.Forefoot.Measurement.Right + ' '}
												{orthotic.Postings.Forefoot.Units.Right && orthotic.Postings.Forefoot.Units.Right}
											</div>
											<div className="Exam__details-sub-text">
														Left: {orthotic.Postings.Forefoot.Location.Left && orthotic.Postings.Forefoot.Location.Left + ' '}
												{orthotic.Postings.Forefoot.Measurement.Left && orthotic.Postings.Forefoot.Measurement.Left + ' '}
												{orthotic.Postings.Forefoot.Units.Left && orthotic.Postings.Forefoot.Units.Left}
											</div>
										</div>
									)}
									{(orthotic.Postings.Rearfoot && (
										orthotic.Postings.Rearfoot.Location
												|| orthotic.Postings.Rearfoot.Measurement 
												|| orthotic.Postings.Rearfoot.Units)
									) && (
										<div className="Exam__details-sub-text-section">
											<div className="Exam__details-sub-text">Rearfoot</div>
											<div className="Exam__details-sub-text">
														Right: {orthotic.Postings.Rearfoot.Location.Right && orthotic.Postings.Rearfoot.Location.Right + ' '}
												{orthotic.Postings.Rearfoot.Measurement.Right && orthotic.Postings.Rearfoot.Measurement.Right + ' '}
												{orthotic.Postings.Rearfoot.Units.Right && orthotic.Postings.Rearfoot.Units.Right}
											</div>
											<div className="Exam__details-sub-text">
														Left: {orthotic.Postings.Rearfoot.Location.Left && orthotic.Postings.Rearfoot.Location.Left + ' '}
												{orthotic.Postings.Rearfoot.Measurement.Left && orthotic.Postings.Rearfoot.Measurement.Left + ' '}
												{orthotic.Postings.Rearfoot.Units.Left && orthotic.Postings.Rearfoot.Units.Left}
											</div>
										</div>
									)}
									{orthotic.Postings.Comments && (
										<div className="Exam__details-sub-text-section">
											<div className='Exam__details-sub-text'>Comments</div>
											{valueThenSubTextDivs({value: orthotic.Postings.Comments})}
										</div>
									)}
								</React.Fragment>
							)}
							{orthotic.Modifications && (
								<React.Fragment>
									<h3 className="Exam__details-sub-header">Modifications:</h3>
									{(orthotic.Modifications['Metatarsal Pads'] || orthotic.Modifications['Metatarsal Pads Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Metatarsal Pads'] && <div>Metatarsal Pads</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Metatarsal Pads']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Metatarsal Pads Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Heel Raise'] || orthotic.Modifications['Heel Raise Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Heel Raise'] && <div>Heel Raise</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Heel Raise']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Heel Raise Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['1st Ray Cut-out'] || orthotic.Modifications['1st Ray Cut-out Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['1st Ray Cut-out'] && <div>1st Ray Cut-out</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['1st Ray Cut-out']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['1st Ray Cut-out Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Mortons Extension'] || orthotic.Modifications['Mortons Extension Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Mortons Extension'] && <div>Mortons Extension</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Mortons Extension']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Mortons Extension Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['2-5 Bar'] || orthotic.Modifications['2-5 Bar Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['2-5 Bar'] && <div>2-5 Bar</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['2-5 Bar']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['2-5 Bar Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Gait Plate'] || orthotic.Modifications['Gait Plate Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Gait Plate'] && <div>Gait Plate</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Gait Plate']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Gait Plate Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Deep Heel Cup'] || orthotic.Modifications['Deep Heel Cup Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Deep Heel Cup'] && <div>Deep Heel Cup</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Deep Heel Cup']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Deep Heel Cup Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Neuroma Pad'] || orthotic.Modifications['Neuroma Pad Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Neuroma Pad'] && <div>Neuroma Pad</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Neuroma Pad']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Neuroma Pad Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Heel Spur'] || orthotic.Modifications['Heel Spur Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Heel Spur'] && <div>Heel Spur</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Heel Spur']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Heel Spur Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications.Accomodation || orthotic.Modifications['Accomodation Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications.Accomodation && <div>Accomodation</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications.Accomodation})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Accomodation Comments'], label: 'Comments'})}
										</div>
									)}
									{(orthotic.Modifications['Rigid 1st Extension'] || orthotic.Modifications['Rigid 1st Extension Comments']) && (
										<div className="Exam__details-sub-text-section">
											{orthotic.Modifications['Rigid 1st Extension'] && <div>Rigid 1st Extension</div>}
											{valueThenSubTextDivs({value: orthotic.Modifications['Rigid 1st Extension']})}
											{valueThenSubTextDivs({value: orthotic.Modifications['Rigid 1st Extension Comments'], label: 'Comments'})}
										</div>
									)}
										
								</React.Fragment>
							)}
							{orthotic['Top Cover'] && valueThenSubHeaderSection('Top Cover', orthotic['Top Cover'])}
							{orthotic['Fabrication Instructions'] && valueThenSubHeaderSection('Fabrication Instructions', orthotic['Fabrication Instructions'])}
							{orthotic['OTC Insole'] && valueThenSubHeaderSection('OTC Insole', orthotic['OTC Insole'])}
						</AssessmentInnerContainer>
					))
				)}
				{Footwear && <AssessmentInnerContainer header='Footwear'>
					{Footwear.Brannock && (
						<React.Fragment>
							<h3 className="Exam__details-sub-header">Brannock:</h3>
							{orderedBrannockKeys.map((key, i) => (
								Footwear.Brannock[key] && (
									<div key={i} className="Exam__details-sub-text-section">
										{valueThenSubTextDivs({value: Footwear.Brannock[key], label: key})}
									</div>
								)
							))}
						</React.Fragment>
					)}
					{Footwear.Recommended && (
						<React.Fragment>
							<h3 className="Exam__details-sub-header">Recommended:</h3>
							{orderedRecommendedKeys.map((key, i) => (
								Footwear.Recommended[key] && (
									<React.Fragment key={i}>
										{valueThenSubTextDivs({value: Footwear.Recommended[key], label: key})}
									</React.Fragment>
								)
							))}
						</React.Fragment>
					)}
					{valueThenSubHeaderSection('Features', Footwear.Features)}
					{valueThenSubHeaderSection('Comments', Footwear.Comments)}
					{valueThenSubHeaderSection('Modifications', Footwear.Modifications)}
				</AssessmentInnerContainer>}
				{Compression && <AssessmentInnerContainer header='Compression'>
					<div className="Exam__details-text">
						{/* TODO: ADD UNITS (mmHg) */}
						{valueThenSubHeaderSection('Levels', Compression.Level, ' mmHg')}
						{Compression.Measurements && (
							<React.Fragment>
								<h3 className="Exam__details-sub-header">Measurements:</h3>
								{orderedMeasurementsKeys.map((key, i) => (
									Compression.Measurements[key] && (
										<div key={i} className="Exam__details-sub-text-section">
											{valueThenSubTextDivs({value: Compression.Measurements[key], label: key, units: 'cm'})}
										</div>
									)
								))}
								<div className="Exam__details-sub-text-section">
									{valueThenSubTextDivs(Compression.Measurements.Comments, 'Comments')}
								</div>
							</React.Fragment>
						)}
						{valueThenSubHeaderSection('Sock Size', Compression['Sock Size'])}
						{valueThenSubHeaderSection('Sock Size', Compression['Shoe Size'])}
						{valueThenSubHeaderSection('Sock Types', Compression['Sock Types'])}
						{valueThenSubHeaderSection('Comments', Compression.Comments)}
					</div>
				</AssessmentInnerContainer>}
				{Bracing && <AssessmentInnerContainer header='Bracing'>
					<h3 className="Exam__details-sub-header">Knee:</h3>
					<div className="Exam__details-sub-text">
						{Bracing.Knees && (
							Bracing.Knees.map((brace, i) => (
								<div key={i} className="Exam__details-sub-text-section">
									{orderedKneeBraceKeys.map((key, i) => (
										brace[key] && (
											<React.Fragment key={i}>
												{key === 'Thigh Size' || key === 'Knee Size' || key === 'Calf Size'
													? valueThenSubTextDivs({value: brace[key], label: key, units: 'cm'})
													: valueThenSubTextDivs({value: brace[key], label: key})}
											</React.Fragment>
										)
									))}
								</div>
							))
						)}
					</div>
					<h3 className="Exam__details-sub-header">Ankle:</h3>
					{Bracing.Ankles && (
						Bracing.Ankles.map((brace, i) => (
							<div key={i} className="Exam__details-sub-text-section">
								{orderedAnkleBraceKeys.map((key, i) => (
									brace[key] && (
										<React.Fragment key={i}>
											{key === 'Ankle Size'
												? valueThenSubTextDivs({value: brace[key], label: key, units: 'cm'})
												: valueThenSubTextDivs({value: brace[key], label: key})}
										</React.Fragment>
									)
								))}
							</div>
						))
					)}
				</AssessmentInnerContainer>}
				{Accessories && <AssessmentInnerContainer header='Accessories'>
					{valueThenSubHeaderSection('Paramedical Services', Accessories['Paramedical Services'])}
					{valueThenSubHeaderSection('Foams/Creams Recommendations', Accessories['Foams/Creams Recommendations'])}
					{valueThenSubHeaderSection('Products', Accessories.Products)}
					{valueThenSubHeaderSection('Products Comments', Accessories['Products Comments'])}
				</AssessmentInnerContainer>}
			</div>
		);
	}
}
 
export default AssessmentTreatment;


// WEBPACK FOOTER //
// ./src/views/Assessment/AssessmentTreatment.js